module.exports = __webpack_public_path__ + "static/media/respondology-logo.cd1498ec.png";